import {Module} from '@fantasmagames/slot/src/common/Module';
import {Views} from '@fantasmagames/slot/src/common/view/Views';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {LogicEvents} from '@fantasmagames/slot/src/logic/LogicEvents';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';
import {FreeSpinsEvents} from '@fantasmagames/slot/src/modules/freespins/intro/FreeSpinsEvents';
import {StopAutoplayButtonEvents} from '@fantasmagames/slot/src/modules/keypad/stopautoplaybutton/StopAutoplayButtonEvents';
import {FreeRoundsScreenEvents} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenEvents';
import {InFreeRoundsEvents} from '@fantasmagames/slot/src/modules/microgaming/inFreeRounds/InFreeRoundsEvents';
import {InFreeRoundsView} from '@fantasmagames/slot/src/modules/microgaming/inFreeRounds/InFreeRoundsView';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';

export class InFreeRoundsModule extends Module<InFreeRoundsView> {
	protected _isInAutoplay: boolean = false;

	protected _canEnableDiscardButton: boolean = true;

	public restore(): void {
		super.restore();

		if (this.logic.isFreeSpinsStarted) {
			this.view.disableDiscardButton();
			this.view.hideDiscardButton();
		}
	}

	protected enterFirstState(): void {}

	protected setupStates(): void {}

	protected setupViews(): void {
		if (this.system.shouldUseMultipleViews()) {
			this.setView(Views.MICROGAMING_INFREEROUNDS_VIEW_MOBILE);
		} else {
			this.setView(Views.MICROGAMING_INFREEROUNDS_VIEW);
		}
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreeGamesStarted);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesEnded);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesEnded);
		this.on(FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesEnded);
		this.on(FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesEnded);
		this.on(LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
		this.on(LogicEvents.INIT_RESPONSE, this.onInitResponse);

		this.on(FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStarted);
		this.on(FlowModuleEvents.BONUS_GAME_RESTORED, this.onBonusGameRestored);
		this.on(FlowModuleEvents.CAN_SPIN, this.onCanSpin);
		this.on(ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);

		this.on(AutoplayMenuEvents.ACCEPTED, this.onAutoplayStarted);
		this.on(StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopped);

		this.on(FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
		this.on(FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);

		this.onViewEmitEvent(InFreeRoundsView.DISCARD_PRESSED, InFreeRoundsEvents.DISCARD_PRESSED);
	}

	protected onFreeSpinsOutroFinished(): void {
		this._canEnableDiscardButton = true;
		if (
			(this.logic as RecodeLogic).currentFreeGameProgress &&
			(this.logic as RecodeLogic).currentFreeGameProgress.gamesRemaining !== 0
		) {
			this.view.enableDiscardButton();
			this.view.showDiscardButton();
		}
	}

	protected onFreeSpinsIntroStarted(): void {
		this.view.disableDiscardButton();
		this._canEnableDiscardButton = false;
		this.view.hideDiscardButton();
	}

	protected onAutoplayStarted(): void {
		this.view.disableDiscardButton();
		this._isInAutoplay = true;
	}

	protected onAutoplayStopped(): void {
		this._isInAutoplay = false;
	}

	protected onFreeGamesStarted(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;
		if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
			this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
		} else {
			if (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().gamesRemaining === 0) {
				this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
			} else {
				this.view.showInGameScreen(logic.getCurrentFreeGamesData(), logic.currentFreeGameProgress, this._isInAutoplay);
				if (!this.logic.isFreeSpinsStarted) {
					this.view.enableDiscardButton();
					this.view.showDiscardButton();
				}
			}
		}
	}

	protected onSpinResponse(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;
		if (logic.isInFreeRounds) {
			if (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().gamesRemaining === 0) {
				this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
			} else {
				this.view.showInGameScreen(logic.getCurrentFreeGamesData(), logic.currentFreeGameProgress, this._isInAutoplay);
			}
		}
	}

	protected onInitResponse(): void {
		const logic: RecodeLogic = this.logic as RecodeLogic;
		if (logic.hasRestore || logic.hasBonusGameFreeGamesRestore) {
			this.view.disableDiscardButton();
		}
	}

	protected onFreeGamesEnded(): void {
		this.view.removeScreen();
	}

	protected onBonusGameStarted(): void {
		this.view.disableDiscardButton();
	}

	protected onBonusGameRestored(): void {
		this.view.disableDiscardButton();
	}

	protected onReelsSpinningStarted(): void {
		this.view.disableDiscardButton();
	}

	protected onCanSpin(): void {
		if (!this.logic.isFreeSpinsStarted && this._canEnableDiscardButton) {
			this.view.enableDiscardButton();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/microgaming/inFreeRounds/InFreeRoundsModule.ts